import React, { useCallback } from 'react'
import { Box, Text } from '@usap/uicomponents'
import OrderItem from './OrderItem'

import {
  Container,
  SubHeading,
  LiveChat,
  Spacer,
} from './Order.css'

export default function Orders({
  isDesktop,
  config,
  items,
  orderStatus,
  navigateToRMA,
  orderDetails,
  setReturnDetailsData,
  setDisplayReturnDetails,
  creditStatus,
  returnRequestStatus,
  orderId,
  formatBrand,
  OpenChatHandler,
  coreConfig,
}) {
  return (
    <Container>
      <Box round="xsmall" pad="small">
        <SubHeading wrap>
          <Box
            width="100%"
          >
            <Box direction="row" gap="xsmall">
              <Text size="xsmall" color="grayText">
                ORDER STATUS:
              </Text>
              <Text size="xsmall" color="dark-2" weight="bold">
                {orderStatus}
              </Text>
            </Box>

            <Text size="xsmall" color="dark-2">
              {'If you have any questions or concerns, you can contact us through our '}
              <LiveChat
                onClick={OpenChatHandler}
                href="#"
                rel="noreferrer"
              >
                Live Chat
              </LiveChat>
              . Our chat agents are available Mon-Sun from 4 AM to 8 PM PST.
            </Text>
          </Box>

          <Spacer
            gap="xsmall"
          />
        </SubHeading>
      </Box>

      <Box>
        {items.map((product, index) => (
          <OrderItem
            key={index}
            config={config}
            orderDetails={orderDetails}
            itemDetails={orderDetails.items[index]}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            product={product}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            isDesktop={isDesktop}
            navigateToRMA={navigateToRMA}
            orderId={orderId}
            orderStatus={orderStatus}
            formatBrand={formatBrand}
            OpenChatHandler={OpenChatHandler}
            coreConfig={coreConfig}
          />
        ))}
      </Box>
    </Container>
  )
}
